export default "__VITE_ASSET__B4hlX2Lm__"